<template>
  <div class="page">
    <div class="header">
      <div>
        <div style="color: #FFF93E; font-size: 4.1vw; margin-bottom: .7vw">{{ lightUpGiftCount }}</div>
        <div>收礼点亮</div>
      </div>
      <img src="/static/images/1508/divide.png" class="divide"/>
      <div>
        <div style="color: #FFF93E; font-size: 4.1vw; margin-bottom: .7vw">{{ achievementGiftCount }}</div>
        <div>礼物成就</div>
      </div>
    </div>

    <div class="content">
      <div class="tab" :style="tabList.length > 3? 'overflow-x: auto' : ''">
        <div v-for="(item, index) in tabList" :key="index" class="tabItem" :class="tabIndex == index? 'active' : ''" @click="tabClick(index)">
          {{item.name}}
          <div class="lineBlock" v-if="tabIndex == index"></div>
        </div>
      </div>
      <div class="list" v-if="list.length">
        <div v-for="(item, index) in list" :key="index" class="listItem" @click="toGainHonor(item)">
          <div class="itemBody">
            <div class="schedule">{{item.collectedGiftCount}}/{{item.giftCount}}</div>
            <div class="status" :class="item.collectedStatus == 'collecting'? '' : 'active'">
              {{item.collectedStatus == "collecting"? '收集中' :
                item.collectedStatus == "finish"? '已收集' : '已过期'}}
            </div>
            <div class="square">
              <img :src="item.iconUrl" class="itemImg" :style="item.collectedStatus == 'finish'? '' : 'filter: grayscale(100%)'"/>
            </div>
            <div class="name">{{item.name}}</div>
          </div>
          <div class="reward" :class="item.collectedStatus == 'finish' && !item.isReceiveAward? 'active' : ''" @click.stop="drawDown(item)">
            {{ item.isReceiveAward? '已领取' : '领取' }}{{ item.exchangeType == 'avatar_frame'? '' : formatPrice(item.exchangeValue) }}{{item.exchangeType == 'balance'? '余额' :
              item.exchangeType == 'integral'? '积分' :
                  item.exchangeType == 'avatar_frame'? '头像框' : ''}}
          </div>
        </div>
      </div>
      <div v-else class="noMore">
        暂无数据
      </div>
    </div>

    <surprised v-model="surprisedShow" :awardsText="surprised.awardsText" :iconUrl="surprised.iconUrl" @close="surprisedShow = false"></surprised>
  </div>
</template>

<script>
import { getGiftBook, getGiftBookList, receiveAward } from "@/api/1508/honor";
import {Dialog, Toast} from "vant";
import Decimal from "decimal.js";
import surprised from "@/views/1508/surprised"
export default {
  name: "achievement",

  components:{
    surprised
  },

  data(){
    return{
      tabIndex: 0,
      list: [],
      tabList:[],
      achievementGiftCount: null,
      lightUpGiftCount: null,
      surprisedShow: null,
      surprised: {
        awardsText: '',
        iconUrl: '',
      }
    }
  },

  methods:{
    formatPrice(price) {
      if (price != null) {
        return Decimal.div(price, 100).toString()
      }
      return ''
    },

    drawDown(item){ //领取奖励
      if(item.collectedStatus != 'finish' || item.isReceiveAward){
        return
      }
      Toast.loading({
        mask: true,
        message: '请稍候...',
        duration: 0
      })
      receiveAward({
        giftBookId: item.id
      }).then(res=>{
        Toast.clear()
        const data = res.data;
        if (data.code == 0) {
          let amount = item.exchangeType == 'avatar_frame'? '' : this.formatPrice(item.exchangeValue)
          let type = item.exchangeType == 'balance'? '余额' : item.exchangeType == 'integral'? '积分' : item.exchangeType == 'avatar_frame'? '头像框' : ''
          this.surprised.awardsText = amount + type
          if( item.exchangeType == 'avatar_frame'){
            this.surprised.iconUrl = item.avatarFrameUrl
          }else if(item.exchangeType == 'integral'){
            this.surprised.iconUrl = "/static/images/1508/integral.png"
          }else if(item.exchangeType == 'balance'){
            this.surprised.iconUrl = "/static/images/1508/balance.png"
          }
          this.surprisedShow = true
          this.getGiftBookList()
        } else {
          Dialog.alert({
            title: '领取失败',
            message: data.msg
          })
        }
      })
    },

    tabClick(idx){
      this.tabIndex = idx

      this.getGiftBookList()
    },

    toGainHonor(item){
      this.$router.push('/clerk/gainHonor?id=' + item.id)
    },

    getGiftBook(){ //礼物成就
      return new Promise((resolve,reject) =>{
        getGiftBook().then(res=>{
          const data = res.data;
          if (data.code == 0) {
            resolve (this.tabList = data.list)
          } else {
            Dialog.alert({
              title: '获取失败',
              message: data.msg
            })
          }
        })
      })
    },

    getGiftBookList(){
      getGiftBookList({
        categoryId: this.tabList[this.tabIndex].id
      }).then(res=>{
        const data = res.data;
        if (data.code == 0) {
          this.list = data.giftBookList
          this.achievementGiftCount = data.achievementGiftCount
          this.lightUpGiftCount = data.lightUpGiftCount
        } else {
          Dialog.alert({
            title: '获取失败',
            message: data.msg
          })
        }
      })
    },
  },

  activated() {
    let that = this

    async function get(){
      await that.getGiftBook()
      that.getGiftBookList()
    }
    get()
  },

  mounted(){

  }
}
</script>

<style scoped lang="less">
.page{
  height: 100vh;
  padding: 12.3vw 3.7vw 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;

  &:after{
    content: '';
    position: absolute;
    top: -9.8vw;
    left: 0;
    right: 0;
    height: 100%;
    background: url("/static/images/1508/honorBg.png");
    background-size: 100%;
    background-repeat: no-repeat;
    z-index: -1;
  }

  &:before{
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 100%;
    background: #20203C;
    background-size: 100%;
    background-repeat: no-repeat;
    z-index: -1;
  }

  .header{
    font-size: 2.7vw;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-align: center;
    width: 37.5vw;
    margin-top: 2.5vw;

    .divide{
      width: .4vw;
      height: 9.7vw
    }
  }

  .content{
    width: 100%;
    box-sizing: border-box;
    margin: 5vw 0 5.8vw;
    background: #fff;
    border-radius: 2.7vw;
    padding: 0 3.6vw 1.9vw;
    position: relative;
    display: flex;
    flex-direction: column;
    min-height: 0;

    .tab{
      display: -webkit-box;
      min-height: 10.7vw;
      line-height: 10.7vw;

      .tabItem{
        width: 31.66%;
        margin-right: 2.5%;
        text-align: center;
        font-size: 3vw;
        color: #575757;
        position: relative;
        //padding: 3.95vw 0;

        &.active{
          color: #030303;
          font-weight: bold;
        }

        .lineBlock{
          position: absolute;
          bottom: 1.8vw;
          left: 50%;
          transform: translateX(-50%);
          height: .5vw;
          border-radius: 222px;
          width: 3.6vw;
          background: #775DF6;
          margin: 1vw auto 0;
        }
      }
    }

    .list{
      margin-top: 1vw;
      display: flex;
      flex-wrap: wrap;
      overflow-y: auto;

      .listItem{
        width: 31.86%;
        margin-right: 2.2%;
        text-align: center;
        font-size: 0;
        margin-bottom: 7.5vw;

        &:nth-child(3n){
          margin-right: 0;
        }

        .itemBody{
          background: #F4F5F7;
          border-radius: 1.3vw;
          margin-bottom: 3vw;
          padding: 5.1vw 2.9vw 1.65vw;
          box-sizing: border-box;
          font-size: 2.9vw;
          color: #333;
          font-weight: bold;
          position: relative;

          .schedule{
            position: absolute;
            top: .7vw;
            right: 1.5vw;
          }

          .status{
            position: absolute;
            left: 0;
            top: 0;
            color: #fff;
            font-size: 2.1vw;
            background: linear-gradient(90deg, #AF8EF6, #83C0F9);
            border-radius: 1.3vw 0px 1.3vw 0px;
            padding: .45vw 1.65vw;

            &.active{
              background: rgba(0, 0, 0, .2);
            }
          }

          .square{
            padding-bottom: 100%;
            position: relative;

            .itemImg{
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%
            }
          }

          .name{

            text-align: center;
          }
        }
      }

      .reward{
        border-radius: 222px;
        background: #F2F2F2;
        font-size: 2.1vw;
        color: #BFBFBF;
        width: 76%;
        display: inline-block;
        text-align: center;
        line-height: 5.2vw;
        height: 5.2vw;

        &.active{
          background: #775DF6;
          color: #fff;
        }
      }
    }

    .noMore{
      margin: 7vw 0;
      text-align: center;
      color: #999;
      font-size: 2.7vw;
    }
  }
}
</style>